import AHRIToolRelatedProductCarousel from "@crescentParts/Components/AHRIToolRelatedProduct/AHRIToolRelatedProductCarousel";
import TrainingRedirectionPopup from "@crescentParts/Components/Training/TrainingRedirectionPopup";
import getAHRISystemToolHandlerData from "@crescentParts/Handlers/AHRIHandler/AHRIDataHandler";
import locationIcon from "@crescentParts/Icons/Training/Location";
import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import loadAHRIRelatedProducts from "@crescentParts/Store/Data/AHRIRelatedProduct/Handler/AHRIRelatedProductHandler";
import AHRISystemToolAhriSortHandler from "@crescentParts/Store/Data/AHRISystemData/Handler/AHRISorting";
import AHRISystemToolAhriDataHandler from "@crescentParts/Store/Data/AHRISystemData/Handler/FetchProduct";
import { getAHRISystemCurrentPageState } from "@crescentParts/Store/Data/AHRISystemToolPagination/AHRISystemToolPaginationSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getRelatedProductsCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import addCartLines from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps, SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    ahriData?: any;
    loader: boolean;
    inventoryLoader: boolean;
    setLoader: (e: any) => void;
    id: string;
    redirectHandler?: (from: string) => void;
}
type sortByField = {
    [key: string]: string[];
};

const sortByFields: sortByField = {
    AHRINo: ["AHRINo"],
    // ModelStatus: ["ModelStatus"],
    OutdoorUnit: ["OutdoorUnit"],
    AirHandler: ["AirHandler"],
    Furnace: ["Furnace"],
    Family: ["Family"],
    AC_HeatPump: ["AC_HeatPump"],
    Family_SEER2: ["Family_SEER2"],
    Furnace_BTU: ["Furnace_BTU"],
    Outdoor_Unit_Tonnage: ["Outdoor_Unit_Tonnage"],
    Indoor_Type: ["Indoor_Type"],
    C25_Tax_Credit_Qualified: ["C25_Tax_Credit_Qualified"],
    Indoor_Position: ["Indoor_Position"],
    Cooling_Capacity: ["Cooling_Capacity"],
    Cooling_Capacity2: ["Cooling_Capacity2"],
    EER2: ["EER2"],
    SEER2: ["SEER2"],
    Heating_Capacity2: ["Heating_Capacity2"],
    HSPF2: ["HSPF2"],
    refrigerant: ["refrigerant"],
};
const mapStateToProps = (state: ApplicationState & CustomApplicationState, Props: OwnProps) => {
    const getCurrentPage = getAHRISystemCurrentPageState(state);
    const {
        productSettings: { showAddToCartConfirmationDialog },
        cartSettings: { addToCartPopupTimeout },
    } = getSettingsCollection(state);

    const createAccountPageLink = getPageLinkByPageType(state, "CreateAccountPage");
    const isCartLoading = getCurrentCartState(state).isLoading;
    const { isUpdatingCart } = state.context;
    return {
        ahriData: state.cpeState.AHRISystemData.ahriData,
        ahriSorting: state.cpeState.AHRISystemData.ahriSorting,
        ahriAttributes: state.cpeState.AHRISystemData.attributes,
        getCurrentPage,
        isAddToCartButtonDisabled: isCartLoading || isUpdatingCart,
        showAddToCartConfirmationDialog,
        addToCartPopupTimeout,
        isAuthenticated: state.context.session?.isAuthenticated,
        createAccountUrl: createAccountPageLink ? `${createAccountPageLink.url}` : undefined,
        location: getLocation(state),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        cartPageUrl: getPageLinkByPageType(state, "CartPage")?.url,
    };
    
};

const mapDispatchToProps = {
    AHRISystemToolAhriSortHandler,
    getAHRISystemToolHandlerData,
    AHRISystemToolAhriDataHandler,
    addToCart: makeHandlerChainAwaitable<Parameters<typeof addToCart>[0], CartLineModel>(addToCart),
    addCartLines: makeHandlerChainAwaitable(addCartLines),
    loadCurrentCart,
    loadRealTimeInventory,
    loadRealTimePricing,
    loadCarouselProducts,
    loadAHRIRelatedProducts
}
export interface AttributesDropdownStyles {
    attributesValueContainer?: InjectableCss;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    img?: LazyImageProps;
    dataTable?: DataTableProps;
    prodContainer?: InjectableCss;
    dataTableCell?: DataTableCellProps;
    dataTableBody?: DataTableBodyProps;
    productNumber?: InjectableCss;
    attributeValues?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    addToCartButton?: ButtonPresentationProps;
    inventoryLoadStyle?: InjectableCss;
    fixedColumn?: InjectableCss;
    stickyheader?: InjectableCss;
    fixedColumn1?: InjectableCss;
    hideAddToCartText?: InjectableCss;
    fixAddToCartBtn?: InjectableCss;
    fixAhriText?: InjectableCss;
    fixOutdoor?: InjectableCss;
    fixAirCoil?: InjectableCss;
    fixFurnace?: InjectableCss;
    modal?: ModalPresentationProps;
    innerWrapper?: InjectableCss;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    addButton?: ButtonPresentationProps;
    saveButton?: ButtonPresentationProps;
    confirmationModal?: ModalPresentationProps;
    ahriRedirectionModal?: ModalPresentationProps;
    location?: TypographyPresentationProps;
}
interface KeyValueModel {
    [key: string]: any;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const attributeStyles: AttributesDropdownStyles = {
    attributesValueContainer: {
        css: css`
            margin-top: 28px;
            overflow: auto;
        `,
    },
    gridContainer: {
        gap: 28,
        css: css`
            padding: 40px 0px;
            justify-content: space-between;
            > div[class^="GridOffset"] {
                justify-content: center;
                max-width: 100%;
                margin-left: 2px;
            }
        `,
    },
    gridItem: {
        css: css`
            flex-basis: 30%;
            max-width: 30%;
            border: 1px solid #cccccc;
            margin: 0px 14px 28px 14px !important;
        `,
    },
    img: {
        css: css`
            width: 100%;
            height: 250px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        `,
    },
    prodContainer: {
        css: css`
            width: 100%;
        `,
    },
    productNumber: {
        css: css`
            margin: 0 !important;
            padding: 4px;
            font-weight: bold;
        `,
    },
    attributeValues: {
        css: css`
            padding: 5px;
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            height: 200px;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 20px;
        `,
    },
    noResultsText: {
        size: 16,
        weight: 600,
    },
    hideAddToCartText: {
        css: css`
            position: sticky;
            left: 0;
            z-index: 1;
        `,
    },
    fixAhriText: {
        css: css`
            left: 146.5px;
            position: sticky;
            z-index: 1;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                        `,
                        css`
                            position: static;
                        `,
                        null,
                        null,
                        null
                    ]
                )
            }    
        `,
    },
    fixedColumn: {
        css: css`
            position: sticky;
            left: 0;
            background-color: white;
        `,
    },
    fixedColumn1: {
        css: css`
            position: sticky;
            left: 146.5px;
            background-color: white;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                        `,
                        css`
                            position: static;
                        `,
                        null,
                        null,
                        null
                    ]
                )
            }
        `,
    },
    fixAddToCartBtn: {
        css: css`
            > td:nth-child(3) {
                position: sticky;
                left: 241px;
                background-color: white;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                        `,
                        css`
                            position: static;
                        `,
                        null,
                        null,
                        null
                    ]
                )
            }
            }
            > td:nth-child(4) {
                position: sticky;
                left: 375.5px;
                background-color: white;
                ${({ theme }: { theme: BaseTheme }) =>
                  breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                            `,
                        css`
                            position: static;
                            `,
                        null,
                        null,
                        null
                    ]
                  )
                }
            }
            > td:nth-child(5) {
                position: sticky;
                left: 559.5px;
                background-color: white;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                            `,
                        css`
                            position: static;
                            `,
                        null,
                        null,
                        null
                    ]
                )
            }
        `,
    },
    fixFurnace: {
        css: css`
            position: sticky;
            left: 559.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                        `,
                        css`
                            position: static;
                        `,
                        null,
                        null,
                        null
                    ]
                )
            }
        `,
    },
    fixAirCoil: {
        css: css`
            position: sticky;
            left: 375.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                        `,
                        css`
                            position: static;
                        `,
                        null,
                        null,
                        null
                    ]
                )
            }
        `,
    },
    fixOutdoor: {
        css: css`
            position: sticky;
            left: 241px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: static;
                        `,
                        css`
                            position: static;
                        `,
                        null,
                        null,
                        null
                    ]
                )
            }
        `,
    },
    inventoryLoadStyle: {
        css: css`
            font-weight: bold;
            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `
    },
    modal: {
        size: 1200,
        sizeVariant: "large",
        cssOverrides: {
            modalBody: css`
                overflow-y: visible;
                max-height: calc(100% - 0px) !important;
                height: 100% !important;
            `,
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
            `,
        },
    },
    innerWrapper: {
        css: css`
        overflow-y: auto;
        max-height: 85vh !important;
        padding: 0px 15px;
            ul[class^="PopoverStyle"] {
                max-height: 150px !important;
            }
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    addButton: {
        css: css`
            margin-left: 10px;
        `,
    },
    saveButton: {
        css: css`
            margin-left: 10px;
        `,
    },
    buttonsWrapper: {
        css: css`
            margin-top: 30px;
            text-align: right;
        `,
    },
    confirmationModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
            `,
        },
    },
    ahriRedirectionModal: {
        sizeVariant: "small",
    },
    location: {
        variant: "p",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
        `,
    },
};

const styles = attributeStyles;

const DisplayProducts: React.FC<Props> = ({
    ahriData,
    loader,
    inventoryLoader,
    ahriSorting,
    ahriAttributes,
    getCurrentPage,
    getAHRISystemToolHandlerData,
    AHRISystemToolAhriSortHandler,
    AHRISystemToolAhriDataHandler,
    showAddToCartConfirmationDialog,
    addToCartPopupTimeout,
    addCartLines,
    loadCurrentCart,
    loadRealTimeInventory,
    setLoader,
    loadRealTimePricing,
    id,
    loadAHRIRelatedProducts,
    isAuthenticated,
    createAccountUrl,
    location,
    signInUrl,

}) => {
    const toasterContext = React.useContext(ToasterContext);
    const [inventoryAPILoader, setInventoryLoader] = React.useState(false);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [relatedProducts, setRelatedProducts] = React.useState([]);
    const [loadRealtimePricingInventory, setLoadRealtimePricingInventory] = React.useState(false);
    const [isPopupOpen, setPopupOpen] = React.useState(false); // State for popup visibility

    const queryParams: any = parseQueryString(location.search);
    const history = useHistory();

    const closePopUp = () =>{
        setPopupOpen(false);
        }

    const headerClick = (sortField: string) => {
        const parameter: KeyValueModel = {};
        const previousSort = ahriSorting ?? "";
        const [previousPrimaryField] = previousSort.split(",");
        const direction = previousPrimaryField === sortField ? " DESC" : "";
        const _sort = sortByFields[sortField].map(field => `${field}${direction}`).join(", ");
        AHRISystemToolAhriSortHandler({ ahriSorting: _sort });
        if(ahriAttributes) {
            Object.keys(ahriAttributes).forEach(( attribute ) => {
                const key = attribute.replace(/ /g, "_")
                const data = ahriAttributes[attribute].map((attr: any) => attr.label).join(",");
                parameter[key] = data;
            });
        }
        setLoader(true);
        setInventoryLoader(true);
        AHRISystemToolAhriDataHandler({
            ahriData: null,
            ahriPagination: {},
        });
        getAHRISystemToolHandlerData({
            Family: parameter["brand"],
            AC_HeatPump: parameter["aC_or_Heat_Pump"],
            Outdoor_Unit_Tonnage: parameter["outdoor_Unit_Tonnage"],
            Family_SEER2: parameter["seer2_Family"],
            Indoor_Type: parameter["indoor_Type"],
            Furnace_BTU: parameter["furnace_BTU"],
            Indoor_Position: parameter["indoor_Position"],
            C25_Tax_Credit_Qualified: parameter["25C_Tax_Credit_Qualified"],
            page: getCurrentPage.ahriSystemToolPageNumber,
            Sort: _sort || "",
            search: "",
            refrigerant: parameter["refrigerant"],
            onSuccess: result => {
                if (result) {
                    setLoader(false);
                    const ahriDataModified = JSON.parse(JSON.stringify(result.data));
                    ahriDataModified?.forEach((ahri: any) => {
                        const ahriProduct = ahri?.productId?.split(",") ?? [];
                        ahriProduct.forEach((ahriP: string) => {
                            const id = ahriP.split(":");
                            ahri[id[0]] = {
                                productId: id[1],
                                qtyOnHand: parseInt(id[2], 10)
                            }
                        });
                    });
                    AHRISystemToolAhriDataHandler({
                        ahriData: ahriDataModified,
                        ahriPagination: result.pagination
                    });
                    setInventoryLoader(false);
                }
            }          
        });
    }

    const filterProductIds = (data: any) => {
        const ids: any = {};
        data.filter((product: any) => product.productId).forEach((product: any) => {
            const ahriProduct = product.productId.split(",");
            ahriProduct.forEach((ahri: string) => {
                ids[ahri.split(":")[1]] = ahri.split(":")[0];
            });
        });
        return ids;
    }

    const sorted = (sortField: string) => {
        let sorted: boolean | string = false;

        if (!ahriSorting) {
            return sorted;
        }
        const [primaryField] = ahriSorting.split(",");
        if (primaryField === sortField) {
            sorted = "ascending";
        } else if (primaryField === `${sortField} DESC`) {
            sorted = "descending";
        }
        return sorted as SortOrderOptions;
    };
    const handleAddToCart = async (productId: string, value: any) => {
        const productIds: any = [];
        productId.split(",").map((productID: any) => productID.split(":")[1]).forEach((pId: string) => {
            productIds.push({
                productId: pId,
                unitOfMeasure: "",
                qtyOrdered: 1
            })
        });
        setLoadRealtimePricingInventory(true);
        setModalIsOpen(true);
        const cartLinesCollection = (await addCartLines({ productInfos: productIds })) as CartLineCollectionModel;
        const isQtyAdjusted = cartLinesCollection.cartLines?.some(cartLine => cartLine.isQtyAdjusted) ?? false;
        if (showAddToCartConfirmationDialog) {
            Promise.all(productId.split(",").map((productID: any) => productID.split(":")[1]).map((pId: string) => {
                const apiParameter = {
                    productId: pId,
                    relationship: "Accessory",
                    pageSize: 999,
                }                        
                return getRelatedProductsCollectionV2(apiParameter);
            }))
            .then((data) => {            
                const allProducts: any = [];
                if(data) {
                    data?.forEach((productsDTO: any) => {
                        if(productsDTO && productsDTO?.products && productsDTO?.products?.length > 0) {
                            allProducts.push(productsDTO?.products);
                        }
                    })
                }
                setLoadRealtimePricingInventory(false);
                loadAHRIRelatedProducts({
                    products: allProducts.flat(),
                    onComplete(result) {
                        
                    },
                });
            });
            toasterContext.addToast({
                body: <ProductAddedToCartMessage isQtyAdjusted={isQtyAdjusted} multipleProducts={false} />,
                messageType: "success",
                timeoutLength: isQtyAdjusted ? 1000 * 60 * 60 * 24 * 365 : addToCartPopupTimeout,
            });
        }
        loadCurrentCart({ shouldLoadFullCart: true });
    }

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const redirectHandler = (from: string) => {
        if(from === "createAccount") {
            if (!createAccountUrl) {
                return;
            }
            history.push(createAccountUrl);
        } else {
            const returnUrl = location.pathname + location.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
                }
        }
    }


    return (
        <StyledWrapper data-test-selector="productsAttributeContainer">
            <StyledWrapper {...styles.attributesValueContainer}>
                {loader ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ) : ahriData && ahriData.length === 0 ? (
                    <StyledWrapper {...styles.noResultsContainer}>
                        <Typography {...styles.noResultsText}>{translate("No Data Available")}</Typography>
                    </StyledWrapper>
                ) : (
                    <>
            <Modal
                headline={translate("Create Account or Sign In")}
                {...styles.ahriRedirectionModal}
                isOpen={isPopupOpen}
                handleClose={closePopUp}>
                <TrainingRedirectionPopup
                    redirectHandler={redirectHandler}
                />
            </Modal>
                     
                     <DataTable {...styles.dataTable}>
                        <DataTableHead>
                            <DataTableHeader id="add-to-cart" {...styles.hideAddToCartText}>
                                {translate("")}
                            </DataTableHeader>
                            <DataTableHeader
                                {...styles.fixAhriText}
                                onSortClick={() => headerClick("AHRINo")}
                                sorted={sorted("AHRINo")}
                            >
                                {translate("AHRI")}
                            </DataTableHeader>
                            {/* <DataTableHeader
                                onSortClick={() => headerClick("ModelStatus")}
                                sorted={sorted("ModelStatus")}
                            >
                                {translate("Model Status")}
                            </DataTableHeader> */}
                            <DataTableHeader
                                onSortClick={() => headerClick("OutdoorUnit")}
                                sorted={sorted("OutdoorUnit")}
                                {...styles.fixOutdoor}
                            >
                                {translate("Outdoor Unit")}
                            </DataTableHeader>
                            <DataTableHeader
                                onSortClick={() => headerClick("AirHandler")}
                                sorted={sorted("AirHandler")}
                                {...styles.fixAirCoil}
                            >
                                {translate("A-Coil or Air Handler")}
                            </DataTableHeader>
                            <DataTableHeader
                                {...styles.fixFurnace}
                                onSortClick={() => headerClick("Furnace")}
                                sorted={sorted("Furnace")}
                            >
                                {translate("Furnace")}
                            </DataTableHeader>
                            {/* <DataTableHeader onSortClick={() => headerClick("Family")} sorted={sorted("Family")}>{translate("Brand")}</DataTableHeader>
                        <DataTableHeader onSortClick={() => headerClick("AC_HeatPump")} sorted={sorted("AC_HeatPump")}>{translate("AC/Heat Pump")}</DataTableHeader>
                        <DataTableHeader onSortClick={() => headerClick("Family_SEER2")} sorted={sorted("Family_SEER2")}>{translate("Seer2 Family")}</DataTableHeader> */}
                            <DataTableHeader
                                onSortClick={() => headerClick("Furnace_BTU")}
                                sorted={sorted("Furnace_BTU")}
                            >
                                {translate("Furnace BTU")}
                            </DataTableHeader>
                            <DataTableHeader
                                onSortClick={() => headerClick("Outdoor_Unit_Tonnage")}
                                sorted={sorted("Outdoor_Unit_Tonnage")}
                            >
                                {translate("Outdoor Unit Tonnage")}
                            </DataTableHeader>
                            <DataTableHeader
                                onSortClick={() => headerClick("Indoor_Type")}
                                sorted={sorted("Indoor_Type")}
                            >
                                {translate("Indoor Type")}
                            </DataTableHeader>
                            <DataTableHeader
                                onSortClick={() => headerClick("C25_Tax_Credit_Qualified")}
                                sorted={sorted("C25_Tax_Credit_Qualified")}
                            >
                                {translate("25C Tax Credit Qualified")}
                            </DataTableHeader>
                            <DataTableHeader
                                onSortClick={() => headerClick("Indoor_Position")}
                                sorted={sorted("Indoor_Position")}
                            >
                                {translate("Indoor Position")}
                            </DataTableHeader>
                            {/* <DataTableHeader
                                onSortClick={() => headerClick("Cooling_Capacity")}
                                sorted={sorted("Cooling_Capacity")}
                            >
                                {translate("Cooling Capacity")}
                            </DataTableHeader> */}
                            <DataTableHeader
                                onSortClick={() => headerClick("Cooling_Capacity2")}
                                sorted={sorted("Cooling_Capacity2")}
                            >
                                {translate("Cooling Capacity 2")}
                            </DataTableHeader>
                            <DataTableHeader onSortClick={() => headerClick("EER2")} sorted={sorted("EER2")}>
                                {translate("EER2")}
                            </DataTableHeader>
                            <DataTableHeader onSortClick={() => headerClick("SEER2")} sorted={sorted("SEER2")}>
                                {translate("SEER2")}
                            </DataTableHeader>
                            <DataTableHeader
                                onSortClick={() => headerClick("Heating_Capacity2")}
                                sorted={sorted("Heating_Capacity2")}
                            >
                                {translate("Heating Capacity 2")}
                            </DataTableHeader>
                            <DataTableHeader onSortClick={() => headerClick("HSPF2")} sorted={sorted("HSPF2")}>
                                {translate("HSPF2")}
                            </DataTableHeader>
                            <DataTableHeader onSortClick={() => headerClick("refrigerant")} sorted={sorted("refrigerant")}>
                                {translate("Refrigerant")}
                            </DataTableHeader>
                            {/* <DataTableHeader id="add-to-cart">{translate("")}</DataTableHeader> */}
                        </DataTableHead>
                        <DataTableBody>
                            {ahriData &&
                                ahriData.length > 0 &&
                                ahriData?.map((value: any, index: number) => {
                                    const getColor = (item: any, data: any) => {
                                        let color = "";
                                        if(value?.productId) {
                                            if (data[item]?.qtyOnHand < 1) {
                                                color = "#f1cfcf";
                                            } else if (data[item]?.qtyOnHand >= 1 && data[item]?.qtyOnHand < 4) {
                                                color = "#f7d879";
                                            } else if (data[item]?.qtyOnHand >= 4 && data[item]?.qtyOnHand < 8) {
                                                color = "#f9f998";
                                            } else if (data[item]?.qtyOnHand >= 8) {
                                                color = "#9bed9b";
                                            }
                                        }
                                        const tableRowStyle: DataTableCellProps = {
                                            css: css`
                                                background-color: ${color} !important;
                                            `,
                                        };
                                        return tableRowStyle;
                                    };
                                    return (
                                        <DataTableRow key={index} {...styles.fixAddToCartBtn}>
                                            <DataTableCell
                                                className="ahri-record"
                                                {...styles.fixedColumn}
                                                key={`add-to-cart-${index}`}
                                            >
                                                <Button
                                                    disabled={!value?.productId || loadRealtimePricingInventory}
                                                    {...styles.addToCartButton}
                                                    onClick={() => {
                                                        if (!isAuthenticated) {
                                                            // If not logged in, show the popup
                                                            setPopupOpen(true);
                                                        } else {
                                                            // If logged in, proceed with adding to cart
                                                            handleAddToCart(value?.productId, value);
                                                        }
                                                    }}
                                                    data-test-selector="ahri_systemTable_Reorder"
                                                >
                                                    {translate("Add To Cart")}
                                                </Button>
                                               
                                            </DataTableCell>
                                            <DataTableCell
                                                {...styles.fixedColumn1}
                                                className="ahri-record"
                                                key={`ahriNo-${index}`}
                                            >
                                                {value["ahriNo"] || "-"}
                                            </DataTableCell>
                                            {/* <DataTableCell className="ahri-record" key={`model Status-${index}`}>
                                                {value["model Status"] || "-"}
                                            </DataTableCell> */}
                                            <DataTableCell
                                                {...styles.fixedColumn1}
                                                className="ahri-record"
                                                {...getColor(value["outdoor Unit"], value)}
                                                key={`outdoor Unit-${index}`}
                                            >
                                                <StyledWrapper>{value["outdoor Unit"] || "-"}</StyledWrapper>
                                                {(inventoryLoader || inventoryAPILoader) && (
                                                    <StyledWrapper {...styles.inventoryLoadStyle}></StyledWrapper>
                                                )}
                                            </DataTableCell>
                                            <DataTableCell
                                                className="ahri-record"
                                                {...getColor(value["air Handler"], value)}
                                                key={`air Handler-${index}`}
                                            >
                                                <StyledWrapper>{value["air Handler"] || "-"}</StyledWrapper>
                                                {(inventoryLoader || inventoryAPILoader) && (
                                                    <StyledWrapper {...styles.inventoryLoadStyle}></StyledWrapper>
                                                )}
                                            </DataTableCell>
                                            <DataTableCell
                                                className="ahri-record"
                                                {...getColor(value["furnace"], value)}
                                                key={`furnace-${index}`}
                                            >
                                                <StyledWrapper>{value["furnace"] || "-"}</StyledWrapper>
                                                {(inventoryLoader || inventoryAPILoader) && (
                                                    <StyledWrapper {...styles.inventoryLoadStyle}></StyledWrapper>
                                                )}
                                            </DataTableCell>
                                            {/* <DataTableCell className="ahri-record" key={`family-${index}`}>{value["family"] || "-"}</DataTableCell>
                                        <DataTableCell className="ahri-record" key={`ac Heat Pump-${index}`}>{value["ac Heat Pump"] || "-"}</DataTableCell>
                                        <DataTableCell className="ahri-record" key={`family SEER2-${index}`}>{value["family SEER2"] || "-"}</DataTableCell> */}
                                            <DataTableCell className="ahri-record" key={`furnace BTU-${index}`}>
                                                {value["furnace BTU"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell
                                                className="ahri-record"
                                                key={`outdoor Unit Tonnage-${index}`}
                                            >
                                                {value["outdoor Unit Tonnage"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`indoor Type-${index}`}>
                                                {value["indoor Type"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell
                                                className="ahri-record"
                                                key={`25C Tax Credit Qualified-${index}`}
                                            >
                                                {value["25C Tax Credit Qualified"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`indoor Position-${index}`}>
                                                {value["indoor Position"] || "-"}
                                            </DataTableCell>
                                            {/* <DataTableCell className="ahri-record" key={`cooling Capacity-${index}`}>
                                                {value["cooling Capacity"] || "-"}
                                            </DataTableCell> */}
                                            <DataTableCell className="ahri-record" key={`cooling Capacity2-${index}`}>
                                                {value["cooling Capacity2"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`eeR2-${index}`}>
                                                {value["eeR2"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`seeR2-${index}`}>
                                                {value["seeR2"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`heating Capacity2-${index}`}>
                                                {value["heating Capacity2"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`hspF2-${index}`}>
                                                {value["hspF2"] || "-"}
                                            </DataTableCell>
                                            <DataTableCell className="ahri-record" key={`refrigerant-${index}`}>
                                                {value["refrigerant"] || "-"}
                                            </DataTableCell>
                                            {/* <DataTableCell className="ahri-record" key={`add-to-cart-${index}`}>
                                                <Button
                                                    disabled={!value?.productId}
                                                    {...styles.addToCartButton}
                                                    onClick={() => handleAddToCart(value?.productId, value)}
                                                    data-test-selector="ahri_systemTable_Reorder"
                                                >
                                                    {translate("Add To Cart")}
                                                </Button>
                                            </DataTableCell> */}
                                        </DataTableRow>
                                    );
                                })}
                        </DataTableBody>
                    </DataTable>
                    </>
                    
                )}
            </StyledWrapper>
            <Modal
                {...styles.modal}
                headline={translate("Related Products")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                <LoadingOverlay
                    loading={loadRealtimePricingInventory}
                    css={css`
                        width: 100%;
                    `}
                >
                    <StyledWrapper {...styles.innerWrapper} data-test-selector="relatedProductsModal">
                        {loadRealtimePricingInventory ? null: <AHRIToolRelatedProductCarousel/>}
                    </StyledWrapper>
                </LoadingOverlay>
            </Modal>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayProducts);